import styled from 'styled-components';
import { DatePicker } from '@fluentui/react';
import { ErrorCircleFilled } from '@fluentui/react-icons';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form/dist/types';
import { Dropdown } from '@fluentui/react-components';

interface FormSectionTitleProps {
  isRequired?: boolean;
}

export const FormTitle = styled.h1`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`;

export const FormSectionTitle = styled.label<FormSectionTitleProps>`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  align-items: center;

  ${({ isRequired }) =>
    isRequired &&
    `
    &:after {
        content: '*';
        color: red;
        margin-left: 5px;
    }
  `}
`;

export const OptionsWrapper = styled.div`
  max-height: 250px;
`;

export const DatePickerStyle = styled(DatePicker)`
  width: 100%;

  .ms-TextField-field {
    background: ${(props) => props.theme.colorNeutralBackground3};
    color: ${(props) => props.theme.colorNeutralForeground4};
  }

  [class*='readOnlyPlaceholder-'],
  .ms-DatePicker-event--without-label.msDatePickerDisabled {
    color: ${(props) => props.theme.colorNeutralForeground4};
  }

  .ms-TextField-fieldGroup {
    border: 1.5px solid ${(props) => props.theme.popupInputBorderColor};
    border-radius: 4px;
    overflow: hidden;
  }

  box-shadow:
    0px 3.2px 7.2px rgba(0, 0, 0, 0.13),
    0px 0.6px 1.8px rgba(0, 0, 0, 0.11);
  border-radius: 4px;

  .ms-TextField-field {
    padding: 1px 10px;
  }

  @media (max-width: 710px) {
    height: 32px;
    .ms-TextField-field,
    [class*='readOnlyPlaceholder-'],
    .ms-DatePicker-event--without-label.msDatePickerDisabled,
    .ms-TextField-fieldGroup {
      height: 100%;
      margin-bottom: 20px;
    }
  }

  input:disabled {
    background: ${(props) => props.theme.popupInputMainBackground};
  }

  .readOnlyPlaceholder-103 {
    font-size: 14px;
  }
`;

export const DatePickerContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const AlertIcon = styled(ErrorCircleFilled)`
  color: #b10e1c;
  font-size: 16px;
  margin-right: 3px;
`;

export const StyledDropdown = styled(Dropdown)<{
  error:
    | FieldError
    | Merge<
        FieldError,
        FieldErrorsImpl<{
          label: string;
          value: string;
        }>
      >;
}>`
  border: 1.5px solid
    ${(props) =>
      props.error
        ? props.theme.popupErrorColor
        : props.theme.popupInputBorderColor};
  border-radius: 4px;
  overflow: hidden;
`;
